import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {EquipmentEnums, EquipmentCardEnums, EquipmentCardInterfaces} from '@namespaces/equipment.namespace';
import {CalibrationLabelPipe} from '@pipes/calibration-label/calibration-label.pipe';

@Component({
    selector: 'app-equipment-calibration-preview',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ng-container *ngIf="message">
            <span [class]="cssClass">
                {{message}} <br>
                {{popoverMessage}}
            </span>
        </ng-container>
        <div *ngIf="calibration">
            Свидетельство № {{calibration.number}} от {{calibration.date_begin}}
            <ng-container *ngIf="calibration?.files?.length">
                <br>
                <a href="javascript:;" (click)="onShowClick()">Показать копию</a>
            </ng-container>
        </div>
        <div *ngIf="linkMessage"><a href="javascript:;" (click)="addCalibration.emit()">{{linkMessage}}</a></div>
    `
})

export class CalibrationPreviewComponent implements OnChanges {
    @Input() calibration: EquipmentCardInterfaces.Card.LastCalibration;
    @Input() calibrationStatus: EquipmentEnums.VerificationStatus;
    /**
     * Должно ли оборудование поверяться / калиброваться?
     */
    @Input() is_calibrated: boolean;

    @Output() showFiles = new EventEmitter();
    @Output() addCalibration = new EventEmitter();

    constructor(
        private calibrationLabelPipe: CalibrationLabelPipe,
    ) {
    }

    public message = '';
    public popoverMessage = '';
    public cssClass = '';
    public linkMessage = '';

    ngOnChanges() {
        this.cssClass = '';
        this.message = '';
        this.popoverMessage = '';
        this.linkMessage = '';

        if (this.calibration) {
            /**
             * Для просроченной поверки будет класс с ошибкой, а для скорого окончания - предупреждающий
             * @type {string}
             */
            this.cssClass =
                (
                    this.calibration.status === EquipmentCardEnums.CalibrationExpiredStatus.expired ||
                    this.calibration.status === EquipmentCardEnums.CalibrationExpiredStatus.close
                ) ? 'text-danger' : (this.calibration.status === EquipmentCardEnums.CalibrationExpiredStatus.soon) ? 'text-warning' : '';

            switch (this.calibration.status) {
                case EquipmentCardEnums.CalibrationExpiredStatus.expired : {
                    this.popoverMessage = `
                        ${this.calibrationLabelPipe.transform(this.calibrationStatus, 'Поверка', 'Калибровка')}
                        просрочена
                    `;
                    break;
                }
                case EquipmentCardEnums.CalibrationExpiredStatus.close : {
                    this.popoverMessage = `
                        До конца
                        ${this.calibrationLabelPipe.transform(this.calibrationStatus, 'поверки', 'калибровки')}
                        осталось менее месяца
                    `;
                    break;
                }
                case EquipmentCardEnums.CalibrationExpiredStatus.soon : {
                    this.popoverMessage = `
                        До конца
                        ${this.calibrationLabelPipe.transform(this.calibrationStatus, 'поверки', 'калибровки')}
                        осталось менее трех месяцев
                    `;
                    break;
                }
            }

            this.message = `
                        ${this.calibrationLabelPipe.transform(this.calibrationStatus, 'Поверено', 'Откалибровано')}
                        до ${this.calibration.date_end}
                    `;

        } else {
            /**
             * Если нет поверки/калибровки, но она обязательна
             */
            if (this.is_calibrated) {
                this.cssClass = 'text-danger';
                this.message = `
                        Не
                        ${this.calibrationLabelPipe.transform(this.calibrationStatus, 'поверено', 'откалибровано')}
                    `;
                this.popoverMessage = ``;
                this.linkMessage = `
                        Добавить сведение о
                        ${this.calibrationLabelPipe.transform(this.calibrationStatus, 'поверке', 'калибровке')}
                    `;
            }
        }
    }

    onShowClick() {
        this.showFiles.emit();
    }
}
